import { render, staticRenderFns } from "./PortalLayout.vue?vue&type=template&id=0b097fa7&scoped=true"
import script from "./PortalLayout.vue?vue&type=script&lang=js"
export * from "./PortalLayout.vue?vue&type=script&lang=js"
import style0 from "./PortalLayout.vue?vue&type=style&index=0&id=0b097fa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b097fa7",
  null
  
)

export default component.exports